import { toQueryString } from "src/utils/misc";
import { api } from ".";
export const fetchUCI = async (param)=>{
    let { id , type  } = param;
    const { data  } = await api.get("/uci".concat(toQueryString({
        id,
        type
    })));
    return data;
};
export const fetchUCIList = async (params)=>{
    const { data  } = await api.get("/uci/list".concat(toQueryString({
        ...params
    })));
    return data;
};
